import { Schema as S } from "effect";

const DataItemSchema = S.Struct({
  // Required fields
  _id: S.String,
  start: S.String,
  end: S.String,
  calendar: S.String,
  // Optional fields - API may not always return all
  lastEditedDate: S.optional(S.String),
  duration: S.optional(S.Number),
  plannedDuration: S.optional(S.Number),
  type: S.optional(S.String),
  adhoc: S.optional(S.Boolean),
  patient: S.optional(S.String),
  scheduled: S.optional(S.Number),
  allDay: S.optional(S.Boolean),
  severity: S.optional(S.String),
  urgency: S.optional(S.Number),
  userDescr: S.optional(S.String),
  resource: S.optional(S.String),
  resourceBased: S.optional(S.Boolean),
  linkByResource: S.optional(S.String),
  title: S.optional(S.String),
  arrivalTime: S.optional(S.String),
  scheduletype: S.optional(S.String),
  employee: S.optional(S.String),
});

// Update response returns an array of updated records
export const UpdateScheduleResponseSchema = S.Array(DataItemSchema);

export type UpdateScheduleResponse = S.Schema.Type<
  typeof UpdateScheduleResponseSchema
>;
